const washInstructionsReducer = (state, action) => {
    switch (action.type) {
        case 'CHANGE_SLIDE':
            let newSlide = action.slideIndex;
            if (action.slideIndex < 0) {
                newSlide = 0;
            }
            if (action.slideIndex >= state.totalSlides) {
                newSlide = state.totalSlides - 1;
            }

            return {
                ...state,
                currentSlide: newSlide
            };
        default:
            return state;
    }
};

export default washInstructionsReducer;
